import Icon from '../components/Icon.vue'

Icon.register({
  'file-export': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M384 121.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9zM571 308c6.6 6.6 6.6 17.4 0 24l-95.7 96.5c-10.1 10.1-27.4 3-27.4-11.3v-65.2h-64v-64h64v-65.1c0-14.3 17.3-21.4 27.4-11.3zM192 336c0 8.8 7.2 16 16 16h176v136c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136c0 13.2 10.8 24 24 24h136v128h-176c-8.8 0-16 7.2-16 16v32z'
      }
    ]
  }
})
